// LoginModal.js
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
// import ForgotPasswordModal from "../ForgotPasswordModal/ForgotPasswordModal";
import "toastr/build/toastr.min.css";
// import toastr from "toastr";
// import axios from "axios";
import Form from 'react-bootstrap/Form';

import './Support.css'
import {  isValidEmail } from "../../Helpers/Utility";
import { postData } from "../../Services/Api";
import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import { LuEye, LuEyeOff } from "react-icons/lu";

export default function Support(props) {
 const { onHide} = props
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    comments: ""
  });
  const [ setMessage] = useState("")
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    var newErrors = {};

    if (formData.name.trim() === "") {
      newErrors.name = "Name is required";
    }

    if (formData.email.trim() === "") {
      newErrors.email = "Email is required";
    } else if (!isValidEmail(formData.email)) {
      newErrors.email = 'Enter a valid email';
    }

    if (formData.comments.trim() === "") {
      newErrors.comments = "Comment is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const data = {
        name: formData.name,
        email: formData.email,
        comments: formData.comments
      }

      const postDataResponse = await postData('submit-support-request', data);
      if (postDataResponse.success) {
        setMessage(postDataResponse.data.message);
        toast.success(postDataResponse.data.message);
        setFormData({ name: "", email: "", comments: "" });
        setErrors({});
        onHide();
      } else {
        setMessage(postDataResponse.data.message);
        toast.error("Something went wrong. Please try again");
        setErrors({});
        onHide();
      }
    } catch (error) {
      setMessage(error.message);
      toast.error(error.message);
      setErrors({});
      onHide();
    }

  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div className="position-absolute start-0 top-0 p-5 z-n1 greenOval rounded-circle"></div>
      <div className="container-fluid shadow-lg">
        <div className="row no-gutter">
          <div className="col-md-6 bg-white rounded-start-5">
            <div className="d-flex justify-content-start align-items-center login   py-5">
              <div className="card border-0 w-100 px-4 ps0 pe0">
                <div className="card-title text-start ">
                  <h3 className="p-3 pb-0">CONTACT US</h3>
                  <small className="p-3 text-secondary">
                    Get in touch with us we're here to assist you!
                  </small>
                </div>
                <div className="card-body">
                  <form>
                    <div className="mb-3">
                      <label htmlFor="username" className="form-label">
                        Full Name*
                      </label>
                      <input
                        type="text"
                        className="form-control customFormText px-3 py-2 rounded-5"
                        placeholder="Name"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                      {errors.name && (
                        <div className="text-danger">{errors.name}</div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label htmlFor="username" className="form-label">
                        Email*
                      </label>
                      <input
                        type="text"
                        className="form-control customFormText px-3 py-2 rounded-5"
                        placeholder="Email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      {errors.email && (
                        <div className="text-danger">{errors.email}</div>
                      )}
                    </div>
                    <div className='mb-3'>
                      <label htmlFor="username" className="form-label">
                        Comments*
                      </label>
                      <Form.Control
                        as="textarea"
                        id="comments"
                        name="comments"
                        className='customFormText'
                        placeholder="Leave a comment here"
                        style={{ height: '100px' }}
                        value={formData.comments}
                        onChange={handleChange}
                      />
                      {errors.comments && (
                        <div className="text-danger">{errors.comments}</div>
                      )}
                    </div>

                    <div className=" mt-5">
                      <Button className="btn btn-default w-auto startedBtn rounded-5 pt-2 pb-2 fs-5 px-5" onClick={handleSubmit} >
                        Submit
                      </Button>

                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 rounded-end-2 d-none d-md-flex bg-image-support"></div>
        </div>
      </div>
      <div className="position-absolute p-5 bottom-0 end-0 z-n1 redOval rounded-circle"></div>
    </Modal>
  );
}
